module.exports = __webpack_public_path__ + "static/img/team-build-05.4f63f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-05.jpg
// module id = C1rC
// module chunks = 1